var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.$checkPermission(_vm.role, _vm.permission))?_vm._t("default"):(_vm.error)?_c('div',{staticClass:"flix-alert flix-alert-danger"},[_vm._v(" keine Zugriffsberechtigung ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }